import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Server, Users, Shield, Mail, ChevronRight } from 'lucide-react'
import { PageHeader, fadeUp } from '@personic/shared'
import { buildBreadcrumbs } from '@/config/routes'

export default function TenantBrowser() {
  const breadcrumbs = buildBreadcrumbs('/admin/tenants')

  const adminLinks = [
    { label: 'Tenant Management', href: '/employee/admin', desc: 'View and manage all tenants', icon: Server },
    { label: 'User Management', href: '/employee/features', desc: 'Feature flags and user access', icon: Users },
    { label: 'Attestation Queue', href: '/employee/attestations', desc: 'Review attestation submissions', icon: Shield },
    { label: 'Email Templates', href: '/employee/emails', desc: 'Manage transactional email templates', icon: Mail },
  ]

  return (
    <div>
      <PageHeader
        title="Tenant Operations"
        description="System administration and tenant management tools."
        breadcrumbs={breadcrumbs}
      />

      <motion.div variants={fadeUp} initial="hidden" animate="visible" className="max-w-4xl">
        <div className="rounded-xl border border-warm-200 bg-white p-6 mb-6">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-lg bg-copper-50 flex items-center justify-center">
              <Server className="w-5 h-5 text-copper-500" />
            </div>
            <div>
              <h2 className="font-heading font-semibold text-midnight-800">System Admin</h2>
              <p className="text-xs text-warm-500">Full admin restructuring coming in Phase 4</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {adminLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="flex items-center justify-between p-4 rounded-xl border border-warm-200 bg-white hover:border-copper-300 transition-colors group"
            >
              <div className="flex items-center gap-3">
                <link.icon className="w-4 h-4 text-warm-400 group-hover:text-copper-500" />
                <div>
                  <p className="text-sm font-medium text-midnight-800 group-hover:text-copper-700">{link.label}</p>
                  <p className="text-xs text-warm-500">{link.desc}</p>
                </div>
              </div>
              <ChevronRight className="w-4 h-4 text-warm-300 group-hover:text-copper-500" />
            </Link>
          ))}
        </div>
      </motion.div>
    </div>
  )
}
